import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { companiesWorkSpaceTypeSelector, updateCompaniesWorkSpaceAction } from 'domain/companies';
import { organizationIdSelector } from 'domain/env';

import {
  WorkspaceViewToggleGroup,
  WorkspaceViewToggleButton,
} from 'pages/companies/components/Bar/components/WorkspaceViewToggle/StyledComponents';

import TableChartIcon from '@mui/icons-material/TableChart';
import ViewModuleIcon from '@mui/icons-material/ViewModule';

const WorkspaceViewToggle = () => {
  const dispatch = useDispatch();
  const viewType = useSelector(companiesWorkSpaceTypeSelector);
  const orgId = useSelector(organizationIdSelector);

  const onChange = (event, type) => {
    // value === null - when we click on already selected button
    if (type !== null) {
      dispatch(updateCompaniesWorkSpaceAction({ orgId, type }));
    }
  };

  return (
    <WorkspaceViewToggleGroup exclusive size="small" onChange={onChange} value={viewType}>
      <WorkspaceViewToggleButton value="grid">
        <TableChartIcon />
      </WorkspaceViewToggleButton>
      <WorkspaceViewToggleButton value="tile">
        <ViewModuleIcon />
      </WorkspaceViewToggleButton>
    </WorkspaceViewToggleGroup>
  );
};

export default WorkspaceViewToggle;
